<template>
  <vue-modal :active="active" container-class="bg-smoke" @closed="$emit('closed')">
    <div class="box p-0">
      <order-form :model="order"
                  :resource="resource"
                  :action="action"
                  :canUpdate="canUpdate"
                  :canDelete="canDelete"
                  @created="handleCreated"
                  @updated="handleUpdated"
                  @deleted="handleDeleted"/>
    </div>
  </vue-modal>
</template>

<script>
import { isEqual } from 'lodash';
import modal from '../../mixins/modal';
import resource from '../../mixins/resource';
import OrderForm from './OrderForm.vue';

export default {
  mixins: [modal, resource],

  components: { OrderForm },

  computed: {
    order() {
      return this.data;
    },
    resource() {
      return 'orders';
    },
    hasModel() {
      return !!(this.data && !isEqual(Object.keys(this.data), ['cart']));
    },
  },

  methods: {
    handleCreated(order) {
      Event.fire('orderCreated', order);
    },
    handleUpdated(order) {
      Event.fire('orderUpdated', order);
    },
    handleDeleted(order) {
      Event.fire('orderDeleted', order);
    },
  },
};
</script>